import { SystemIPAddressInsert, SystemIPAddressDelete, SystemIPAddressUpdate, SystemIPAddressGetById, SystemIPAddressGetByName, SystemIPAddressGetList, SystemIPAddressGetPageList } from "@/api/systemipaddress/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    SystemIPAddressInsert(context, payload) {
        return new Promise((resolve, reject) => {


            SystemIPAddressInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    SystemIPAddressUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemIPAddressUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    SystemIPAddressGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            SystemIPAddressGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    SystemIPAddressGetByName(context, payload) {
        return new Promise((resolve, reject) => {
            SystemIPAddressGetByName(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    SystemIPAddressGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemIPAddressGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    SystemIPAddressGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            SystemIPAddressGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}